import type { EmptyStateActionsProps } from "./empty-state.types";

import styles from "./empty-state-actions.module.css";

export function EmptyStateActions({
  children,
  className = "",
  ...props
}: EmptyStateActionsProps) {
  return (
    <div className={`${styles.Container} ${className}`} {...props}>
      {children}
    </div>
  );
}
